// styles
import { TeamHeroWrapper } from './TeamHero.styles';

export function TeamHero() {
  return (
    <TeamHeroWrapper
      bg={{
        xxlarge: '/images/carrier/teamHero/loadsmart-team-hero-xxlarge@2x.jpg',
        large: '/images/carrier/teamHero/loadsmart-team-hero-xxlarge@2x.jpg',
        medium: '/images/carrier/teamHero/loadsmart-team-hero-xxlarge@2x.jpg',
        small: '/images/carrier/teamHero/loadsmart-team-hero-small@2x.jpg',
      }}
    />
  );
}
